const URL = {
    PROCTUR_API_URL: process.env.REACT_APP_PROCTUR_API_URL,
    ENV: process.env.REACT_APP_ENV,
  };
  
  export default URL;
  

